import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { postActionList } from './api';
import { ActionDTO } from './dto/ActionDTO';
import { QueryKey } from '@behavior/QueryKey';

function usePostActionList() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate } = useMutation((actionList: ActionDTO[]) => postActionList(actionList), {
    onSuccess: () => {
      queryClient.invalidateQueries([QueryKey.ACTION]);
    },
    onError: error => {
      toast.error(t('message.title.error.post.action'));
    },
  });
  return mutate;
}

export default usePostActionList;
